/* Template: Date Picker
 ========================================================================== */

 template.search = function () {
	 $('select.perpage').on('change', function() {

        $('#search-filter').submit();

	});

	$('input[name="orderResults"]').on('change', function() {

		$('#search-filter').submit();

	});
};